import type {
  SharedItemBuckets,
  SharedItemInterface,
} from '../interfaces/sharedWithMe.interface';

export function consolidateSharedItems(
  items: SharedItemInterface[],
): SharedItemInterface[] {
  const map = new Map<string, SharedItemInterface>();

  for (const item of items) {
    const existing = map.get(item.storyId);
    if (existing) {
      for (const sharer of item.sharers) {
        if (!existing.sharers.some((s) => s.username === sharer.username)) {
          existing.sharers.push(sharer);
        }
      }
      for (const circle of item.circles) {
        if (!existing.circles.includes(circle)) {
          existing.circles.push(circle);
        }
      }
      if (item.sharedAt > existing.sharedAt) {
        existing.sharedAt = item.sharedAt;
      }
      if (!item.isRead) {
        existing.isRead = false;
      }
    } else {
      map.set(item.storyId, {
        ...item,
        sharers: [...item.sharers],
        circles: [...item.circles],
      });
    }
  }

  return [...map.values()].sort((a, b) => b.sharedAt.localeCompare(a.sharedAt));
}

export function bucketSharedItems(
  items: SharedItemInterface[],
): SharedItemBuckets {
  const now = new Date();
  const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const fourteenDaysAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);

  const buckets: SharedItemBuckets = {
    new: [],
    thisWeek: [],
    lastWeek: [],
    older: [],
  };

  for (const item of items) {
    if (!item.isRead) {
      buckets.new.push(item);
      continue;
    }

    const sharedDate = new Date(item.sharedAt);
    if (sharedDate >= sevenDaysAgo) {
      buckets.thisWeek.push(item);
    } else if (sharedDate >= fourteenDaysAgo) {
      buckets.lastWeek.push(item);
    } else {
      buckets.older.push(item);
    }
  }

  const sortNewest = (a: SharedItemInterface, b: SharedItemInterface) =>
    b.sharedAt.localeCompare(a.sharedAt);

  buckets.new.sort(sortNewest);
  buckets.thisWeek.sort(sortNewest);
  buckets.lastWeek.sort(sortNewest);
  buckets.older.sort(sortNewest);

  return buckets;
}
